var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHowToPlay = function SvgHowToPlay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1026.214 -1646.544)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 27,
    rx: 4,
    transform: "translate(1026.214 1646.544)",
    fill: "#0093ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.122,1658.377q-.461,0-.8-1.1a7.128,7.128,0,0,1-.338-2.1q0-.231.511-.519a5.74,5.74,0,0,1,1.549-.511,10.782,10.782,0,0,1,2.257-.222q4.729,0,4.729,3.3a3.241,3.241,0,0,1-.387,1.623,2.567,2.567,0,0,1-.931,1,4.4,4.4,0,0,1-2.027.626l-.379.016a3.2,3.2,0,0,0,.083.577,3.449,3.449,0,0,1,.082.692q0,.264-.9.4a10.315,10.315,0,0,1-1.557.14q-1.005,0-1.244-.495a5.775,5.775,0,0,1-.239-2.092q0-.379,1.417-.56a2.607,2.607,0,0,0,.964-.347.806.806,0,0,0,.437-.724c0-.306-.247-.461-.742-.461a3.7,3.7,0,0,0-1.557.379A4.916,4.916,0,0,1,1037.122,1658.377Zm2.587,4.482a4.031,4.031,0,0,1,1.714.288,1.193,1.193,0,0,1,.593,1.195q0,1.483-2.307,1.483t-2.307-1.483Q1037.4,1662.858,1039.709,1662.858Z",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHowToPlay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/how-to-play.ae2c3b18.svg";
export { ForwardRef as ReactComponent };